import {Component, OnInit} from '@angular/core';

import {Apis} from '../apis';
import {ApisService} from '../apis.service';
import {UserService} from '../../core/user/user.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'aqx-apis',
  templateUrl: './apis.component.html',
  styleUrls: ['./apis.component.scss']
})
export class ApisComponent implements OnInit {
  apis: Apis;
  searchText: string;

  constructor(private apisService: ApisService, private userService: UserService) {
  }

  ngOnInit() {
    this.getApis();
  }

  getApis(): void {
    this.apisService.getApis()
      .subscribe(apis => {
        this.apisService.enrichApis(apis.list);
        this.getSubscriptionsForApisIfUserIsAuthenticated(apis.list);
        this.apis = apis;
      });
  }

  getThumbnailUri(api) {
    return (this.apisService.getThumbnailUri(api));
  }

  getSubscriptionsForApisIfUserIsAuthenticated(apis) {
    if (this.userService.isUserEntitledApiStore()) {
      this.getSubscriptionsForApis(apis);
    }
  }

  getSubscriptionsForApis(apis) {
    apis.forEach( (api) => {
      this.getSubscriptionsForApi(api);
    });
  }

  getSubscriptionsForApi(api) {
    this.apisService.getSubscriptionsForApi(api.id)
      .subscribe(subscriptions => {
        api.subscriptions = subscriptions;
      });
  }
}
